import { ContentType } from '@candu-ai/content/types';

export const createTitlestxt = {
  [ContentType.Inline]: 'Create Inline Content',
  [ContentType.Modal]: 'Create an Overlay',
  [ContentType.HotspotGroup]: 'Create Hotspot Group',
  [ContentType.Tour]: 'Create Tour',
  [ContentType.Banner]: 'Create Banner',
};

export const namePlaceholderTxt = {
  [ContentType.Inline]: 'Name your Content',
  [ContentType.Modal]: 'Overlay name',
  [ContentType.HotspotGroup]: 'Give the Hotspot Group a name',
  [ContentType.Tour]: 'Give the Tour a name',
  [ContentType.Banner]: 'Banner name',
};

export const createParagraphstxt = {
  [ContentType.Inline]: 'Give your Inline Content a name. You can edit it later.',
  [ContentType.Modal]: 'Give your Overlay a name. You can edit it later.',
  [ContentType.HotspotGroup]:
    'A group can have one or many hotspots. Start by giving the group a name.',
  [ContentType.Tour]: 'A Tour can have one or many steps. Start by giving the Tour a name.',
  [ContentType.Banner]: 'Give your Banner a name. You can edit it later.',
};
